/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProductCompetitionActiveRequest } from '../models/product-competition-active-request';
import { ProductCompetitionActiveResponse } from '../models/product-competition-active-response';
import { ProductCompetitonListRequest } from '../models/product-competiton-list-request';
import { ProductCompetitonListResponse } from '../models/product-competiton-list-response';
import { ProductCompetitonPostRequest } from '../models/product-competiton-post-request';
import { ProductCompetitonPostResponse } from '../models/product-competiton-post-response';

@Injectable({
  providedIn: 'root',
})
export class CompetitionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation v1CompetitionsActivePost
   */
  static readonly V1CompetitionsActivePostPath = '/v1/competitions/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CompetitionsActivePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsActivePost$Plain$Response(params?: {
    body?: ProductCompetitionActiveRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCompetitionActiveResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CompetitionsService.V1CompetitionsActivePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCompetitionActiveResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CompetitionsActivePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsActivePost$Plain(params?: {
    body?: ProductCompetitionActiveRequest
  },
  context?: HttpContext

): Observable<ProductCompetitionActiveResponse> {

    return this.v1CompetitionsActivePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCompetitionActiveResponse>) => r.body as ProductCompetitionActiveResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CompetitionsActivePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsActivePost$Json$Response(params?: {
    body?: ProductCompetitionActiveRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCompetitionActiveResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CompetitionsService.V1CompetitionsActivePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCompetitionActiveResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CompetitionsActivePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsActivePost$Json(params?: {
    body?: ProductCompetitionActiveRequest
  },
  context?: HttpContext

): Observable<ProductCompetitionActiveResponse> {

    return this.v1CompetitionsActivePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCompetitionActiveResponse>) => r.body as ProductCompetitionActiveResponse)
    );
  }

  /**
   * Path part for operation v1CompetitionsListPost
   */
  static readonly V1CompetitionsListPostPath = '/v1/competitions/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CompetitionsListPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsListPost$Plain$Response(params?: {
    body?: ProductCompetitonListRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCompetitonListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CompetitionsService.V1CompetitionsListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCompetitonListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CompetitionsListPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsListPost$Plain(params?: {
    body?: ProductCompetitonListRequest
  },
  context?: HttpContext

): Observable<ProductCompetitonListResponse> {

    return this.v1CompetitionsListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCompetitonListResponse>) => r.body as ProductCompetitonListResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CompetitionsListPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsListPost$Json$Response(params?: {
    body?: ProductCompetitonListRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCompetitonListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CompetitionsService.V1CompetitionsListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCompetitonListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CompetitionsListPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsListPost$Json(params?: {
    body?: ProductCompetitonListRequest
  },
  context?: HttpContext

): Observable<ProductCompetitonListResponse> {

    return this.v1CompetitionsListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCompetitonListResponse>) => r.body as ProductCompetitonListResponse)
    );
  }

  /**
   * Path part for operation v1CompetitionsPostPost
   */
  static readonly V1CompetitionsPostPostPath = '/v1/competitions/post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CompetitionsPostPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsPostPost$Plain$Response(params?: {
    body?: ProductCompetitonPostRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCompetitonPostResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CompetitionsService.V1CompetitionsPostPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCompetitonPostResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CompetitionsPostPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsPostPost$Plain(params?: {
    body?: ProductCompetitonPostRequest
  },
  context?: HttpContext

): Observable<ProductCompetitonPostResponse> {

    return this.v1CompetitionsPostPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCompetitonPostResponse>) => r.body as ProductCompetitonPostResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CompetitionsPostPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsPostPost$Json$Response(params?: {
    body?: ProductCompetitonPostRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCompetitonPostResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CompetitionsService.V1CompetitionsPostPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCompetitonPostResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CompetitionsPostPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CompetitionsPostPost$Json(params?: {
    body?: ProductCompetitonPostRequest
  },
  context?: HttpContext

): Observable<ProductCompetitonPostResponse> {

    return this.v1CompetitionsPostPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCompetitonPostResponse>) => r.body as ProductCompetitonPostResponse)
    );
  }

}
